const images = (reservation = {}, inverted = false) => {
    const settings = reservation.settings

    let source = reservation.source
    if (source) {
        source = source.toLowerCase()
    }

    const images = {
        // 'booking.com': '/static/booking-sources/bookingcom_logo.png',
        // 'bookingcom': '/static/booking-sources/bookingcom_logo.png',
        // 'canadastays': '/static/booking-sources/bookingcom_logo.png',
        // 'airbnb': '/static/booking-sources/airbnb_logo.svg',
        // 'expedia': '/static/booking-sources/expedia_logo.png',
        'website': reservation.company && reservation.company.logo_url,
        'manual': reservation.company && reservation.company.logo_url,
    }

    const invertedImages = {
        // 'booking.com': '/static/booking-sources/white_bookingcom_logo.png',
        // 'bookingcom': '/static/booking-sources/white_bookingcom_logo.png',
        // 'canadastays': '/static/booking-sources/white_bookingcom_logo.png',
        // 'airbnb': '/static/booking-sources/white_airbnb_logo.png',
        // 'expedia': '/static/booking-sources/white_expedia_logo.png',
        'website': reservation.company && reservation.company.logo_contrast_url,
        'manual': reservation.company && reservation.company.logo_contrast_url,
    }

    if (settings.force_guest_portal_company_brand) {
        source = 'website'
    }

    if (inverted) {
        source = (invertedImages[source]) ? source : 'website'
        if (invertedImages[source]) {
            return invertedImages[source]
        }
    }

    if (!images[source]) {
        source = 'website'
    }

    return images[source]
}

export default images;